import { useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { useNavigate } from "react-router-dom";
import { useLoading } from "../loader.jsx";

const LoginCallBack = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const navigate = useNavigate();
  const { showLoader} =  useLoading();
  useEffect(() => {
    console.log("Auth State:", "logged in ");
    localStorage.setItem("AuthState", "logged in ");
    showLoader();
    oktaAuth.handleLoginRedirect()
      .then(() => {
        console.log("Redirect handled");
        localStorage.setItem("RedirectHandled", "redirect handled");
        
        // Check if there's a saved workflow approval URL to redirect to
        const savedWorkflowToken = sessionStorage.getItem('wf_email_token');
        if (savedWorkflowToken) {
          console.log("Redirecting to workflow approval with token");
          sessionStorage.removeItem('wf_email_token');
          navigate(`/workflow-approval?token=${encodeURIComponent(savedWorkflowToken)}`);
        } else {
          console.log("Navigating to home");
          navigate("/home");
        }
      })
      .catch(err => {
        console.error("Login redirect error", err);
      });
  }, [oktaAuth, navigate]);

  // return <div>Signing you in...</div>;
  return <></>;
};

export default LoginCallBack;
